import { render } from "./tender_custom_payment.vue?vue&type=template&id=8328d610"
import script from "./tender_custom_payment.vue?vue&type=script&lang=js"
export * from "./tender_custom_payment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tender/request/tender_custom_payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8328d610"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8328d610', __exports__)) {
    console.log('reload')
    api.reload('8328d610', __exports__)
  }
  
  module.hot.accept("./tender_custom_payment.vue?vue&type=template&id=8328d610", () => {
    console.log('re-render')
    api.rerender('8328d610', render)
  })

}


export default __exports__